import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { minLengthTrimmed } from './min-length-trimmed-validator';

@Component({
  selector: 'app-record-workflow-modal',
  templateUrl: './record-workflow-modal.component.html',
  styleUrls: ['./record-workflow-modal.component.scss'],
})
export class RecordWorkflowModalComponent implements OnInit {
  currentRecordStatus: string;
  newRecordStatus: string;
  onSave: Function;
  onCancel: Function;

  reasonFormGroup = new UntypedFormGroup({
    reason: new UntypedFormControl('', [Validators.required, minLengthTrimmed(10)]),
  });

  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {}

  setDialogProps(props: any) {
    this.onSave = (reason: string) => {
      props.onSave(reason);
      this.modal.close();
    };

    this.onCancel = () => {
      props.onCancel();
      this.modal.close();
    };

    this.reasonFormGroup
      .get('reason')
      ?.setValue(props.recordTransitionReason || '');
  }
}
